export const initialColumnVisibility = {
  project_status: false,
  store_ref_number: false,
  store_status: false,
  store_network: false,
  store_format: false,
  city: false,
  street_name: false,
  street_number: false,
  apartment_number: false,
  postal_code: false,
  province: false,
} as const;
